<ng-content></ng-content>
{{ icon }}
<span *ngIf="fontIconUnicode" [innerHTML]="fontIconUnicode"></span>
<ng-container *ngIf="fontSet === 'fs'">
  <span *ngFor="let item of getPath(); let i = index" class="path{{ i }}"></span>
</ng-container>
